import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.9);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const show = visible && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="hidden md:block fixed bottom-0 left-0 right-0 w-full z-[100]"
          style={{ boxShadow: '0 -2px 12px rgba(0,0,0,0.15)' }}
        >
          <div className="bg-jungle-900 w-full px-6 py-4">
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-5">
              <p className="text-cream font-display font-semibold text-base flex-1">
                Ready to book? Let's make your event unforgettable.
              </p>
              <div className="flex items-center gap-3 shrink-0">
                <Link
                  to="/contact"
                  className="btn-primary text-sm px-6 py-2.5 whitespace-nowrap"
                >
                  Request a Quote
                </Link>
                <button
                  onClick={() => setDismissed(true)}
                  className="text-cream/60 hover:text-cream transition-colors p-1"
                  aria-label="Dismiss"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
